import { useState, useEffect } from 'react';
import partCategoryService from 'services/part-category-service';

import MDButton from 'components/MDButton';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WarningIcon from '@mui/icons-material/Warning';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { ru } from 'date-fns/locale';

export default function ConfirmDeleteDialog({
    attributes,
    open,
    handleClose,
    attNum,
    value,
    editMode,
    id,
}) {
    const [confirmText, setConfirmText] = useState("");
    const [error, setError] = useState(false);
    const [attributesData, setAttributesData] = useState([]);

    useEffect(() => {
        setConfirmText("");
        setError(false);
        setAttributesData(attributes);
    }, [open]);

    const handleDeleteAttribute = async () => {
        // Handle deletion logic here
        if (editMode && (confirmText === "DELETE") && value) {
            try {
                const payload = {
                    data: {
                        type: "partCategory",
                        id: id,
                        attributes: {
                            key: attNum,
                            value: value,
                        }
                    }
                };
                console.log("Payload for delete attribute:", payload);
                // Call the delete attribute service
                await partCategoryService.deleteAttribute(payload, id);
                console.log("Attribute deleted successfully:", attNum);

                setConfirmText("");
                setError(false);
                // Close the dialog and notify parent component
                handleClose(attNum);

            } catch (error) {
                console.error("Error deleting attribute:", error);
            }
            // Deleting an attribute doesnt require backend call in create mode
        } else if (editMode && confirmText === "DELETE") {
            setConfirmText("");
            setError(false);
            // Close the dialog and notify parent component
            handleClose(attNum);
        } else if (!editMode) {

            setConfirmText("");
            setError(false);
            // Close the dialog and notify parent component
            handleClose(attNum);

        } else {
            setError(true);
        }
    };

    const fixCondAttRules = (delAttNum) => {
        if (attributesData[0] && attributesData[0].enableCondAttrs) {
            let options = attributesData[0].options.split(";");
            let rulesArray = [];
            console.log("Base rules", rulesArray)
            for (const opt in options) {
                let condAttRules = attributesData[0][options[opt]].split(";");
                let fixedCondAttRules = [];
                for (const index in condAttRules) {
                    const attributeNum = condAttRules[index];
                    if (attributeNum < delAttNum) {
                        fixedCondAttRules.push(attributeNum);
                    } else if (index > delAttNum) {
                        fixedCondAttRules.push(attributeNum - 1);
                    }
                }
                attributesData[0][options[opt]] = fixedCondAttRules.join(";");
                console.log("Fixed ", options[opt], " to ",attributesData[0][options[opt]]);
            }
            
        }
    }

    const fixAttributesOrder = (delAttNum) => {
        const newAttributesData = { ...attributesData };
        // Remove the attribute at delAttNum
        delete newAttributesData[delAttNum];
        // Decrement the index of remaining attributes
        Object.keys(newAttributesData).forEach(key => {
            if (parseInt(key) > delAttNum) {
                newAttributesData[key - 1] = newAttributesData[key];
                delete newAttributesData[key];
                if (newAttributesData[key - 1].index !== undefined) {
                    newAttributesData[key - 1].index--;
                }
            }
        });
        setAttributesData(newAttributesData);
        console.log("Fixed attributes order:", newAttributesData);
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>

            {editMode ? (
                <>
                    {/* Dialog Title */}
                    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <WarningIcon color='error' />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Irreversible Action
                        </Typography>
                    </DialogTitle>

                    <DialogContent sx={{ pt: 0 }}>

                        {/* Warning Message */}
                        <DialogContentText sx={{ fontWeight: 'bold', mb: 1 }}>
                            This will permanently delete the attribute.
                        </DialogContentText>

                        <DialogContentText sx={{ mb: 2 }}>
                            Once deleted, <strong>this attribute and its data will be removed from all parts in this category</strong>.
                            <span style={{ color: 'error.main', fontWeight: 'bold' }}> This action cannot be undone.</span>
                        </DialogContentText>

                        <DialogContentText sx={{ mb: 2 }}>
                            To confirm, please type <strong>DELETE</strong> below.
                        </DialogContentText>

                        {/* Input field for confirmation text */}
                        <TextField
                            autoFocus
                            placeholder="DELETE"
                            type="text"
                            fullWidth
                            size="small"
                            value={confirmText}
                            onChange={(e) => setConfirmText(e.target.value)}
                            error={error}
                            sx={{
                                mb: 1,
                                '& input': { fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '1px' }
                            }}
                            helperText={error ? "Please type 'DELETE' exactly to confirm deletion" : ""}
                        />

                    </DialogContent>
                </>) : (
                <>
                    {/* Alternative Dialog Title for Create Mode (Not critical)*/}
                    <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Are you sure you want to delete this attribute?
                        </Typography>
                    </DialogTitle>
                </>
            )}

            {/* Cancel/Delete Actions (No/Yes buttons for create mode)*/}
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <MDButton color="dark" variant="gradient" size="small" onClick={handleClose}>{editMode ? "Cancel" : "No"} </MDButton>
                <MDButton color="dark" variant="gradient" size="small" onClick={handleDeleteAttribute} >{editMode ? "Delete" : "Yes"}</MDButton>
            </DialogActions>

        </Dialog>


    );
}
